<template>
	<section class="section-card">
		<div class="section-head">
			<div>
				<h2 class="section-title">设备基本信息</h2>
			</div>
		</div>

		<div class="info-grid info-grid--five">
			<div v-for="item in basicInfoTop" :key="item.label" class="info-field">
				<div class="info-field__label">{{ item.label }}</div>
				<div
					:class="['info-field__value', { 'info-field__value--link': item.link }]"
					@click="handleValueClick(item)"
				>
					{{ item.value }}
				</div>
			</div>
		</div>

		<div class="info-grid info-grid--three">
			<div v-for="item in basicInfoBottom" :key="item.label" class="info-field">
				<div class="info-field__label">{{ item.label }}</div>
				<div
					:class="['info-field__value', { 'info-field__value--link': item.link }]"
					@click="handleValueClick(item)"
				>
					{{ item.value }}
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'BasicInfoSection',
	props: {
		basicInfoTop: {
			type: Array,
			default: () => [],
		},
		basicInfoBottom: {
			type: Array,
			default: () => [],
		},
	},
	methods: {
		handleValueClick(item) {
			if (item && item.link) {
				this.goDeviceDetail(item)
			}
		},
		goDeviceDetail(device) {
			if (!device.deviceId) {
				this.$message.warning('缺少设备ID，暂无法跳转设备详情')
				return
			}
			this.$router.push({
				path: '/device/detail',
				query: {
					deviceId: device.deviceId,
					deviceType: device.deviceTypeId,
				},
			})
		},
	},
}
</script>

<style lang="scss" scoped>
.section-card {
	position: relative;
	padding: 22px 24px 24px;
	background: var(--panel-bg);
	border: 1px solid var(--panel-border);
	border-radius: 12px;
	box-shadow: var(--panel-shadow);
	backdrop-filter: blur(12px);
}

.section-head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	margin-bottom: 18px;
}

.section-title {
	margin: 0;
	color: var(--title);
	font-size: 17px;
	font-weight: 700;
	letter-spacing: 0.01em;
}

.info-grid {
	display: grid;
	gap: 12px;
}

.info-grid + .info-grid {
	margin-top: 12px;
}

.info-grid--five {
	grid-template-columns: repeat(5, minmax(0, 1fr));
}

.info-grid--three {
	grid-template-columns: repeat(3, minmax(0, 1fr));
}

.info-field {
	padding: 4px 0;
	border-bottom: 1px dashed #e6edf3;
}

.info-field__label {
	margin-bottom: 8px;
	font-size: 13px;
	color: var(--muted);
}

.info-field__value {
	font-size: 15px;
	font-weight: 400;
	color: var(--title);
	line-height: 1.4;
}

.info-field__value--link {
	color: var(--primary);
	cursor: pointer;
}

@media (max-width: 1540px) {
	.info-grid--five {
		grid-template-columns: repeat(3, minmax(0, 1fr));
	}

	.info-grid--three {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}
}

@media (max-width: 900px) {
	.section-head {
		flex-direction: column;
		align-items: flex-start;
	}

	.info-grid--five,
	.info-grid--three {
		grid-template-columns: 1fr;
	}
}
</style>
